export default {
  data() {
    return {
      reportsList: [
        {
          label: 'Válvulas e Bombas',
          options: [
            {
              value: {
                type: 'volume',
                IS_DAILY: true,
                equipment: 'actuator'
              },
              text: 'Volume diário'
            },
            {
              value: {
                type: 'flow',
                equipment: 'actuator'
              },
              text: 'Vazão'
            },
            {
              value: {
                type: 'open',
                equipment: 'actuator'
              },
              text: 'aberturas'
            },
            {
              value: {
                type: 'modo',
                equipment: 'actuator'
              },
              text: 'Modo Manual'
            },
            {
              value: {
                type: 'actuators_base_report',
                IS_DAILY: true,
                equipment: 'actuator',
                TITLE_REPORT: 'Relatórios de atuadores',
                TO_PICK_COLUMNS: [
                  'Tempo Acionada',
                  'Vazão Média',
                  'Vazão Média Efetiva',
                  'Volume',
                ],
                // NEED_MANAGEMENT: true
              },
              text: 'Relatório de atuadores'
            },
          ]
        },
        {
          label: 'Hidrômetros',
          options: [
            {
              value: {
                NEED_IMPROVED_REPORTS: true,
                type: 'volume',
                equipment: 'hydrometer'
              },
              text: 'Volume acumulado'
            },
          ]
        },
        {
          label: 'manejo',
          options: [
            {
              value: {
                type: 'daily',
                group: 'management',
                equipmentless: true,
                IS_DAILY: true,
                NEED_MANAGEMENT: true
              },
              text: 'Relatório Diário de manejo'
            },
          ]
        },
        {
          label: 'estação',
          options: [
            {
              value: {
                NEED_IMPROVED_REPORTS: true,
                type: 'station-reads',
                group: 'station',
                equipmentless: true
              },
              text: 'Relatório de leituras'
            },
          ]
        },
        {
          label: 'sensores',
          options: [
            {
              value: {
                type: 'measure',
                equipment: 'sensor'
              },
              text: 'Medição'
            },
            {
              value: {
                type: 'measure-daily',
                equipment: 'sensor',
                IS_DAILY: true,
              },
              text: 'Média diária'
            },
            {
              value: {
                type: 'measure-hourly',
                equipment: 'sensor',
                NEED_MANAGEMENT: true
              },
              text: 'Média horária'
            },
            {
              value: {
                type: 'on-off-daily',
                equipment: 'sensor',
                IS_DAILY: true,
              },
              text: 'ON/OFF'
            },
            {
              value: {
                type: 'measure-accumulated',
                equipment: 'sensor',
                NEED_MANAGEMENT: false,
                IS_DAILY: true,
              },
              text: 'Volume acumulado'
            },
          ]
        },
        {
          label: 'DIRs',
          options: [
            {
              value: { type: 'battery', equipment: 'device' },
              text: 'Bateria'
            },
            {
              value: { type: 'stat', equipment: 'device' },
              text: 'Status'
            },
          ]
        },
      ]
    }
  },
  computed: {
    reportsPropertiesOptions() {
      const tmpReportList = JSON.parse(JSON.stringify(this.reportsList));

      return tmpReportList
        .map(optGroup => {
          optGroup.label = this.capitelizeString(optGroup.label);

          optGroup.options
            .map(opt => {
              opt.text = this.capitelizeString(opt.text);

              const shouldDisableManagementOptions = !this.managementAccess && opt.value.NEED_MANAGEMENT;
              const shouldDisableImprovedOptions = !this.showImprovedReports && opt.value.NEED_IMPROVED_REPORTS;

              const shouldDisable = shouldDisableManagementOptions || shouldDisableImprovedOptions;

              if (shouldDisable) {
                opt.disabled = true;
                opt.disabled_text = this.getDisabledText(opt);

              } else {

                opt.disabled = false;
                opt.disabled_text = this.getDisabledText(opt);

              }

              return opt;
            })

          return optGroup;
        });
    }
  },
  methods: {
    getDisabledText(opt) {
      if (!opt.disabled) {
        return "";

      } else if (opt.value.NEED_MANAGEMENT) {
        return 'requer pacote manejo';

      } else {
        return 'indisponível';

      };
    },
    capitelizeString(str) {
      return str.split(" ")
        .map(word => {
          if (['da', 'de', 'a', 'e', 'o'].includes(word.toLowerCase())) {
            return word.toLowerCase();
          }

          return word[0].toUpperCase() + word.substring(1).toLowerCase();
        })
        .join(" ");
    }
  }
};